// import { getPlansData, searchPlansData } from "@/Api/plans";
// import { SearchComponent } from "@/App/Tenants/Search";
// import { CreateLoaderTable } from "@/components/Loaders";
// import { useEffect, useState } from "react";
// import { ApiDataProps } from "../Tenants";
// import { AddUserBtn } from "@/App/Users/UsersTenant/Add";
// import { ComponentTableUsers } from "@/App/Users/UsersTenant/Table";
// import { TypePageActions } from "../Plans";
// import { useContextData } from "@/components/Context";
import { Main } from "@/components/Main";
import { useParams } from "react-router-dom";
import { UsersTenantPage } from "./UsersTenant";
import { useAuth } from "@/hooks/auth";
import { Users } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";

export type TypeUsersProp = {
  name: string;
  email: string;
  tenant_id: number;
  roles: {
    id: number;
    name: string;
  }[];
  id: number;
  uuid: string;
  is_active: number | boolean;
  created_at: string;
  email_verified_at: any | null;
  photo: string | null;
  user_type_id: number;
  updated_at: string | null;
  deleted_at: string | null;
  user_type: {
    id: number;
    name: string;
  };
  tenant: {
    id: number;
    uuid: string;
    name: string;
    phone: string;
    email: string;
  };
};

export const UsersPage = () => {
  const dataAuth = useAuth();
  const dataAuthUserTenantUuid =
    dataAuth?.user?.user_type_id == 2 ? dataAuth?.user?.tenant?.uuid : "";
  const tenant_uuid = useParams()?.tenant_uuid || dataAuthUserTenantUuid;
  if (tenant_uuid) return <UsersTenantPage tenant_uuid={tenant_uuid} />;

  // const [usersData, setUsersData] = useState({} as ApiDataProps<TypeUsersProp>);
  // const [state, setState] = useState("loading");

  // inicio: pegando dados da api e setando em variavel de estado
  // useEffect(() => {
  //   (async () => {
  //       const { data } = getUsersData();
  //       // console.log(data?.response);
  //       setUsersData(data?.response);
  //     setState("production");
  //   })();
  // }, []);

  // const pageActions: TypePageActions = {
  //   next: async () => {
  //     if (usersData?.current_page < usersData?.last_page) {
  //       setState("loading");

  //       const { data } = await getPlansData(usersData?.current_page + 1);
  //       setUsersData(data.response);
  //       setState("production");
  //     }
  //     return;
  //   },
  //   previous: async () => {
  //     if (usersData?.current_page > 1) {
  //       setState("loading");

  //       const { data } = await getPlansData(usersData?.current_page - 1);
  //       setUsersData(data.response);
  //       setState("production");
  //     }
  //     return;
  //   },
  //   lastPage: async () => {
  //     if (usersData?.current_page !== usersData?.last_page) {
  //       setState("loading");

  //       const { data } = await getPlansData(usersData?.last_page);
  //       setUsersData(data?.response);
  //       // console.log(data);
  //       setState("production");
  //     }
  //     return;
  //   },
  // };

  return (
    <Main>
      <PageHeader
        icon={Users}
        title="Usuarios"
        description="Gerencie os usuarios do sistema"
      />
      <div className="flex flex-col gap-3">
        {/* <SearchComponent
          updateFront={setUsersData}
          setState={setState}
          funcSearch={searchPlansData}
          placeholder="Pesquisar usuário"
        />
        {state === "loading" ? (
          <CreateLoaderTable cols={4} lines={6} />
        ) : (
          <ComponentTableUsers
            dataApi={usersData}
            pageActions={pageActions}
            updateFront={setUsersData}
          />
        )} */}
      </div>
    </Main>
  );
};
